import classNames from 'classnames';

import DynamicSVGColor from '@/components/shared/DynamicSVGColor/DynamicSVGColor';
import { ContentStatus as ContentStatusType } from '@addmile/backend-client';

import { CONTENT_STATUS_COLORS } from '../../const';
import styles from './ContentStatus.module.scss';

const ContentStatus = ({ status }: { status: ContentStatusType }) => {
  const contentStatus = CONTENT_STATUS_COLORS[status];

  const getStatusClasses = (status: ContentStatusType) => {
    switch (status) {
      case ContentStatusType.Online:
        return {
          container: styles.online,
          icon: styles.onlineIcon,
          label: styles.onlineLabel,
        };
      case ContentStatusType.Draft:
        return {
          container: styles.preview,
          icon: styles.previewIcon,
          label: styles.previewLabel,
        };
      case ContentStatusType.Offline:
        return {
          container: styles.offline,
          icon: styles.offlineIcon,
          label: styles.offlineLabel,
        };
      default:
        return {
          container: styles.offline,
          icon: styles.offlineIcon,
          label: styles.offlineLabel,
        };
    }
  };

  const statusClasses = getStatusClasses(status);

  return (
    <div className={classNames(styles.status, statusClasses.container)}>
      <DynamicSVGColor icon={contentStatus.icon} className={statusClasses.icon} />
      <span className={statusClasses.label}>{contentStatus.label}</span>
    </div>
  );
};

export default ContentStatus;
